import { Badge } from '@/components/ui/badge';

interface TestChatBadgeProps {
  isTestChat: boolean;
}

export function TestChatBadge({ isTestChat }: TestChatBadgeProps) {
  if (isTestChat) {
    return (
      <Badge
        variant="default"
        className="bg-blue-500 hover:bg-blue-600 text-white border-transparent"
      >
        TESTE
      </Badge>
    );
  }

  return (
    <Badge variant="destructive">
      REAL
    </Badge>
  );
}
